import { Medal } from "@phosphor-icons/react";

const STYLES = [
  "border-white/25 text-white/70 bg-white/[0.04]",
  "border-sky-300/50 text-sky-200 bg-sky-300/10",
  "border-amber/70 text-amber bg-amber/10 shadow-[0_0_12px_rgba(255,176,0,0.35)]",
];

export const tierStyle = (level) => STYLES[Math.min(Math.max(level, 1), STYLES.length) - 1];

export const TierBadge = ({ name, level, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-1 border px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.15em] whitespace-nowrap ${tierStyle(level)}`}
  >
    <Medal size={11} weight="fill" /> {name}
  </span>
);

export const fmtNum = (n) => Number(n || 0).toLocaleString("en-US");

export const fmtRate = (r) => (Number.isInteger(Number(r)) ? String(Number(r)) : Number(r).toFixed(2));
